import { render, staticRenderFns } from "./ServiceServices.vue?vue&type=template&id=7058b492&scoped=true&"
import script from "./ServiceServices.vue?vue&type=script&lang=js&"
export * from "./ServiceServices.vue?vue&type=script&lang=js&"
import style0 from "./ServiceServices.vue?vue&type=style&index=0&id=7058b492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7058b492",
  null
  
)

export default component.exports